module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vurin14-ee8996198c73995de0f38c8b84921d40.jpg";